module.exports = __webpack_public_path__ + "img/howto_sp05.0e69efff.png";